<template>
  <div class="modal" id="UGModal" tabindex="-1" aria-labelledby="regLabel" aria-hidden="true" data-bs-backdrop="static"
    data-bs-keyboard="false">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header  headclr">
          <h5 class="modal-title" id="exampleModalLabel">User Guide</h5>
          <div class="close-container myfaBtn" data-bs-dismiss="modal" aria-label="Close" v-on:click="hidePopup()">
            <div class="leftright"></div>
            <div class="rightleft"></div>
          </div>
        </div>
        <div class="modal-body modal-bodyHt mdclr">
          <div style="width: 98%;margin-left: 1%; height: 75vh;">
            <section id="content3h" class="sectionh h-100" style="height: 75vh; overflow-x: auto;overflow-x: auto;">
              <div class="h-100" style="margin-top: 10px; width:60%; margin: 0 auto;" v-if="pdfShow">
                <div class="text-center">
                  <div class='text-center my-2'>{{ page }} / {{ pageCount }}</div>
                  <div class="pdf-container">
                    <vue-pdf-embed ref="pdfRef" :source="pdfLink" :page="page" :scale="scale" @rendered="handleDocumentRender" />
                  </div>
                </div>
                <div class="text-center">
                  <button class="uSpl primary left-btn" :disabled="page <= 1" @click="page--">
                    <font-awesome-icon icon="fa-solid fa-angle-left" /> Prev&nbsp;&nbsp;</button>
                  <button class="uSpl primary right-btn" :disabled="page >= pageCount" @click="page++">&nbsp;&nbsp;Next
                    <font-awesome-icon icon="fa-solid fa-angle-right" /></button>
                </div>
              </div>
            </section>
            <section id="content4h" class="sectionh h-100" style="height: 75vh; display:block">
              <div class="row h-100" style="margin-top: 10px">
                <div class="col-9 h-100">
                  <div v-if="isShowVideo" class="h-100">
                    <video-player :options="videoOptions" />
                  </div>
                </div>
                <div class="col-3 h-100">
                  <div>
                    <a class="nonEffect w-100 my-2" :href="pdfLink" download style="padding: 4px 8px;">download user
                      guide</a>
                  </div>
                  <div style="border: 1px solid #777; border-radius: 5px;padding: 0;">
                    <h5 style="margin:10px;">Playlist</h5>
                    <div class="playlistDiv">
                      <div v-for="(topic, index) in myHelpGuide" v-bind:key="topic">
                        <div v-on:click="selectVid(topic, index)" class="row cursor-pointer hoverRow"
                          :class="topic.isActive ? 'active' : ''">
                          <div class="col-6" style="position: relative;">
                            <img v-lazy="require(`../assets/images/track/${topic.img}`)" class="playlistImg"  />
                            <span class="playlistSpan">{{ topic.time }}</span>
                          </div>
                          <div class="col-6">
                            <div class="playlistTxt">
                              {{ topic.title }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal } from 'bootstrap';
import VuePdfEmbed from 'vue-pdf-embed';
import pdfLink from "./../data/OPSight_User_Guide.pdf";
import VidDQ from "./../assets/videos/Data_Quality.mp4";
import VidGS from "./../assets/videos/GettingStarted.mp4";
import VidHome from "./../assets/videos/HomePage.mp4";
import VidSetup from "./../assets/videos/Assessment Setup.mp4";
import VidCluster from "./../assets/videos/Auto_Tagging.mp4";
import VidInsight from "./../assets/videos/Insights.mp4";
import VidInteract from "./../assets/videos/Interact_with_widget.mp4";
import VidInquisight from "./../assets/videos/Inquisight.mp4";
import VidStory from "./../assets/videos/Storyboard.mp4";
import VidAPPM from "./../assets/videos/APPM.mp4";
import VidContact from "./../assets/videos/How_to_contact.mp4";
import VideoPlayer from '../components/smallcomp/VideoPlayer.vue';
import 'vue-multiselect/dist/vue-multiselect.min.css'
export default {
  name: 'userGuide',
  components: {
    VuePdfEmbed,
    VideoPlayer
  },
  props: {
    headerpass: String
  },
  data() {
    return {
      tabsel: 0,
      sectionDetails: [],
      currentPDFPage: 1,
      currPage: "",
      searchQop: "",
      pdfShow: false,
      pagesInPDF: 4,
      pdf: undefined,
      publicPath: process.env.BASE_URL,
      pdfLink,
      page: 1,
      pageCount: 1,
      isShowVideo: false,
      videoOptions: {},
      scale:1,
      myHelpGuide: [
        {
        title: "Getting Started",
        img: "started.png",
        time: "07:05",
        isActive: false,
        pageNumber: 8,
        videoOptions: {
          src: VidGS,
          img: "started.png",
          time: 425,
          tracks: [{
            name: "Introduction to Opsight",
            time: 0
          }, {
            name: "Create Assessment",
            time: 47
          }, {
            name: "Setup and uploading data",
            time: 76
          }, {
            name: "Auto tagging your data",
            time: 160
          }, {
            name: "Checking your data quality",
            time: 212
          }, {
            name: "Viewing Insights and Dashboards",
            time: 253
          }, {
            name: "Ask Questions on your Data",
            time: 300
          }, {
            name: "Build your own storyboard",
            time: 345
          }]
        }
      }, {
        title: "Home Page",
        img: "home.png",
        time: "01:52",
        isActive: false,
        pageNumber: 8,
        videoOptions: {
          src: VidHome,
          img: "home.png",
          time: 112,
          tracks: [{
            name: "Overview of Homepage",
            time: 0
          }, {
            name: "How to switch a tenant",
            time: 15
          }, {
            name: "How to register for a new tenant",
            time: 31
          }, {
            name: "How to search for assessment",
            time: 51
          }, {
            name: "View all own/shared assessments",
            time: 69
          }, {
            name: "How to create a new assessment",
            time: 85
          }]
        }
      }, {
        title: "Setup",
        img: "setup.png",
        time: "07:18",
        isActive: false,
        pageNumber: 15,
        videoOptions: {
          src: VidSetup,
          img: "setup.png",
          time: 438,
          tracks: [{
            name: "Overview of Setup page",
            time: 0
          }, {
            name: "Rename Assessment",
            time: 6
          }, {
            name: "Share an Assessment",
            time: 30
          }, {
            name: "Bookmark an Assessment",
            time: 57
          }, {
            name: "Delete an Assessment",
            time: 70
          }, {
            name: "Expected Data",
            time: 81
          }, {
            name: "Data Template",
            time: 124
          }, {
            name: "Data Preparation- Best practice",
            time: 170
          }, {
            name: "Data Upload",
            time: 223
          }, {
            name: "Data Upload Error",
            time: 247
          }, {
            name: "Data Mapping",
            time: 260
          }, {
            name: "Data Mapping Error",
            time: 333
          }, {
            name: "Update/Append Columns",
            time: 346
          }, {
            name: "Append Rows",
            time: 386
          }, {
            name: "Data Rollback",
            time: 415
          }]
        }
      }, {
        title: "Auto Tagging",
        img: "cluster.png",
        time: "02:43",
        isActive: false,
        pageNumber: 20,
        videoOptions: {
          src: VidCluster,
          img: "cluster.png",
          time: 163,
          tracks: [{
            name: "Overview of autotagging page",
            time: 0
          }, {
            name: "Choose the column",
            time: 9
          }, {
            name: "Interact with Cluster Dashboard",
            time: 52
          }, {
            name: "Search and validate Tags",
            time: 104
          }, {
            name: "Update the Tagged Data",
            time: 153
          }]
        }
      }, {
        title: "Data Quality & Profiling",
        img: "dataQuality.png",
        time: "02:10",
        isActive: false,
        pageNumber: 24,
        videoOptions: {
          src: VidDQ,
          img: "dataQuality.png",
          time: 130,
          tracks: [{
            name: "Overview of Data Quality & Profiling",
            time: 0
          }, {
            name: "What's data quality score",
            time: 15
          }, {
            name: "Understanding Scorecards",
            time: 58
          }, {
            name: "Fields Profiling",
            time: 92
          }]
        }
      }, {
        title: "Insights & Dashboards",
        img: "InsightsDashboard.png",
        time: "07:54",
        isActive: false,
        pageNumber: 28,
        videoOptions: {
          src: VidInsight,
          img: "InsightsDashboard.png",
          time: 474,
          tracks: [{
            name: "Overview of Insights & Dashboards",
            time: 0
          }, {
            name: "Modify View Settings",
            time: 69
          }, {
            name: "Pin/Save View",
            time: 136
          }, {
            name: "Bookmark/Access the other user views",
            time: 178
          }, {
            name: "Page settings",
            time: 215
          }, {
            name: "Portfolio tab",
            time: 262
          }, {
            name: "Key Insights tab",
            time: 287
          }, {
            name: "Overall tab",
            time: 324
          }, {
            name: "Incoming tab",
            time: 337
          }, {
            name: "Acknowledgement tab",
            time: 364
          }, {
            name: "Resolution tab",
            time: 380
          }, {
            name: "Reopen tab",
            time: 396
          }, {
            name: "Reassignment tab",
            time: 416
          }, {
            name: "Change tab",
            time: 432
          }, {
            name: "DIY tab",
            time: 449
          }]
        }
      }, {
        title: "Interact With Widgets",
        img: "interact_with_widgets.png",
        time: "00:43",
        isActive: false,
        pageNumber: 31,
        videoOptions: {
          src: VidInteract,
          img: "interact_with_widgets.png",
          time: 43,
          tracks: [{
            name: "Interact With Widgets",
            time: 0
          }]
        }
      }, {
        title: "Inquisight Page",
        img: "inquisight.png",
        time: "04:29",
        isActive: false,
        pageNumber: 50,
        videoOptions: {
          src: VidInquisight,
          img: "inquisight.png",
          time: 269,
          tracks: [{
            name: "Overview of Inquisight",
            time: 0
          }, {
            name: "Inquisight settings",
            time: 53
          }, {
            name: "Questions supported",
            time: 76
          }, {
            name: "Interacting with the results",
            time: 241
          }]
        }
      }, {
        title: "Storyboard Page",
        img: "storyBoard.png",
        time: "03:16",
        pageNumber: 53,
        isActive: false,
        videoOptions: {
          src: VidStory,
          img: "storyBoard.png",
          time: 196,
          tracks: [{
            name: "Overview of Storyboard",
            time: 0
          }, {
            name: "Pin/Save Storyboard",
            time: 40
          }, {
            name: "Bookmark/Access the other user Storyboard",
            time: 96
          }, {
            name: "Create layout",
            time: 111
          }, {
            name: "Add/Edit Widget",
            time: 153
          }, {
            name: "Full Screen & Download as pdf",
            time: 177
          }]
        }
      }, {
        title: "APPM Dashboard",
        img: "appmDashboard.png",
        time: "20:04",
        pageNumber: 56,
        isActive: false,
        videoOptions: {
          src: VidAPPM,
          img: "appmDashboard.png",
          time: 1204,
          tracks: [
            {
              name: "Overview of APPM",
              time: 0
            },{
              name:"Regenerating the PPR",
              time:173
            },{
              name:"PPR Console",
              time:240
            },{
              name:"Assigning Role",
              time:288
            },{
              name:"Pick and Drop PPR",
              time:437
            },{
              name:"Approve PPR console card",
              time:471
            },{
              name:"View PPR",
              time:531
            },{
              name:"Creating Workflow",
              time:601 
            },{
              name:"PPR Dashboard",
              time:1133
            }
          ]
        }
      }, {
        title: "How to Contact",
        img: "how_to_contact.png",
        time: "00:09",
        isActive: false,
        pageNumber: 72,
        videoOptions: {
          src: VidContact,
          img: "how_to_contact.png",
          time: 9,
          tracks: [{
            name: "How to Contact",
            time: 0
          }]
        }
      },]
    }
  },
  computed: {
  },
  methods: {
    hidePopup() {
      this.isShowVideo = false;
      var myVideo = document.getElementById("video");
      myVideo.pause();
    },
    handleDocumentRender() {
      this.pageCount = this.$refs.pdfRef.pageCount
    },
    showUGModal(currentPage) {
      this.modal.show();
      this.currPage = currentPage;
      const pdf = 0,
        pages = '1',
        info = '';
      this.pdf = pdf;
      this.pdfShow = true;
      this.selectVid(this.myHelpGuide[0], 0)
    },
    decreasePDFPage() {
      this.currentPDFPage = this.currentPDFPage > 1 ? this.currentPDFPage - 1 : 1
    },
    increasePDFPage() {
      this.currentPDFPage = this.currentPDFPage < this.pagesInPDF ? this.currentPDFPage + 1 : this.pagesInPDF
    },
    selectVid(param, position) {
      this.isShowVideo = false;
      for (let index = 0; index < this.myHelpGuide.length; index++) {
        const element = this.myHelpGuide[index];
        element.isActive = false;
      }
      this.myHelpGuide[position].isActive = true;
      setTimeout(() => {
        this.videoOptions = param;
        this.isShowVideo = true;
      }, 500);
    },
    chartVisbility(val) {
      switch (val) {
        case 0:
          break;
        default:
          break;
      }
      this.sectionDetails = [{
        title: "Create Asssessment",
        id: 1,
        subSections: [{
          id: 1,
          question: "1",
          text: "1",
          video: "1"
        }, {
          id: 2,
          question: "2",
          text: "2",
          video: "2"
        }, {
          id: 3,
          question: "3",
          text: "3",
          video: "3"
        }]
      }, {
        title: "Whats the plan",
        id: 2,
        subSections: [{
          id: 1,
          question: "1",
          text: "1",
          video: "1"
        }, {
          id: 2,
          question: "2",
          text: "2",
          video: "2"
        }, {
          id: 3,
          question: "3",
          text: "3",
          video: "3"
        }]
      },]
    }
  },
  mounted() {
    this.modal = new Modal(document.getElementById('UGModal'))
  },
  created() {
  }
}
</script>
<style lang="css" scoped>
.pdf-container {
  padding: 2% 5%;
  ;
}

.pdf-container span:deep(canvas) {
  width: auto !important;
  height: 60vh !important;
}

.primary {
  background: transparent;
  border: none;
  margin-bottom: 32px;
  position: absolute;
  top: 50%;
  transform: translateX(-50%);
  z-index: 5;
}

.primary.left-btn {
  left: 10%;
}

.primary.right-btn {
  right: 10%;
}

.darkTheme .primary {
  color: #fff;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.darkTheme .arrow {
  border-color: #fff;
}

.arrow.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.arrow.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.arrow.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.arrow.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.playlistImg {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ddd;
}

.playlistSpan {
  position: absolute;
  bottom: 3px;
  font-size: 0.6rem;
  padding: 2px 5px;
  right: 15px;
  background: black;
  border-radius: 5px;
  color: white;
  font-weight: bold;
}

.playlistTxt {
  font-weight: bold;
  font-size: 0.8rem;
  margin-left: -5px;
}

.playlistDiv {
  height: 58vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 5px;
  /* background-color: rgba(127, 127, 127, 0.25); */
}

.hoverRow {
  padding: 10px 2px;
}

.hoverRow:hover {
  background-color: rgba(127, 127, 127, 0.25);
}

.hoverRow.active {
  background-color: rgba(204, 85, 0, 0.5);
}

.darkTheme .hoverRow.active {
  background-color: rgba(236, 194, 87, 0.5);
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>